import { createFileRoute } from "@tanstack/react-router";
import { MacroDetail } from "@/components/views/macro/MacroDetail";

export const Route = createFileRoute("/catalog/$macroId")({
  component: MacroDetailRoute,
});

function MacroDetailRoute() {
  const { macroId } = Route.useParams();
  return <MacroDetail slug={macroId} />;
}
